module.exports = __webpack_public_path__ + "img/liangxin-banner2.40e8913b.png";